module.exports = __webpack_public_path__ + "static/img/productDatabase.b3c006fa.svg";